import 'normalize.css'
import '@/styles/app.scss'
import 'core-js/shim'
import 'intersection-observer'
import Vue from 'vue'
import VueScrollto from 'vue-scrollto'
import axios from 'axios'
import device from 'current-device'
import DetectInApp from 'detect-inapp'

import App from './App'
import router from './router'
import ga from '@/scripts/ga'
import SvgSymbol from '@/components/SvgSymbol'
import inview from './directives/inview'

IntersectionObserver.prototype.POLL_INTERVAL = 100

Vue.config.productionTip = false

Vue.device = Vue.prototype.$device = device
Vue.inApp = Vue.prototype.$inApp = new DetectInApp(window.navigator.userAgent)
Vue.http = Vue.prototype.$http = axios
Vue.ga = Vue.prototype.$ga = ga
Vue.bus = Vue.prototype.$bus = new Vue()

Vue.use(VueScrollto)

Vue.component('SvgSymbol', SvgSymbol)

Vue.directive('inview', inview)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
